module.exports = __webpack_public_path__ + "img/rutsche-aussen.72e73808.jpg";